export const occupancyRateData = [
  { label: "Occupied", category: "Occupied", value: 82, color:"#7086FD" },
  { label: "Vaccant", category: "Vaccant", value: 18, color:"#6FD195" },
];

export const vacancyDuration = [
  {
    _id: 1,
    unitId: "UNT-001",
    propertyName: "Lakeside Villas",
    unitName: "A-101",
    daysVacant: 5,
  },
  {
    _id: 2,
    unitId: "UNT-002",
    propertyName: "Mountain View",
    unitName: "B-102",
    daysVacant: 10,
  },
  {
    _id: 3,
    unitId: "UNT-003",
    propertyName: "Downtown Lofts",
    unitName: "C-103",
    daysVacant: 12,
  },
  {
    _id: 4,
    unitId: "UNT-004",
    propertyName: "Sunset Residences",
    unitName: "D-104",
    daysVacant: 16,
  },
  {
    _id: 5,
    unitId: "UNT-005",
    propertyName: "Maple Heights",
    unitName: "E-105",
    daysVacant: 20,
  },
  {
    _id: 6,
    unitId: "UNT-006",
    propertyName: "Lakeside Court",
    unitName: "F-106",
    daysVacant: 25,
  },
  {
    _id: 7,
    unitId: "UNT-007",
    propertyName: "Riverbank Apartments",
    unitName: "G-107",
    daysVacant: 30,
  },
  {
    _id: 8,
    unitId: "UNT-008",
    propertyName: "Hilltop Estates",
    unitName: "H-108",
    daysVacant: 35,
  }
];

export const notifications = [
  {
    _id: 1,
    date: "09/06/2025",
    time: "09:00",
    tenantName: "John Edwin",
    unitId: "ID 1021",
    propertyName: "Property A",
    amount: "UGX 50,000",
    reference: "Bank",
    method: "Email",
    type: "scheduled",
    content: "Your Rent Payment Reminder for the month of June. Please ensure timely payment to avoid late fees."
  },
  {
    _id: 2,
    date: "09/08/2025",
    time: "14:00",
    tenantName: "Jane Doe",
    unitId: "ID 1024",
    propertyName: "Property B",
    amount: "UGX 75,000",
    reference: "Bank",
    method: "Email",
    type: "resend",
    content: "Your Rent Payment Reminder for the month of June. Please ensure timely payment to avoid late fees."
  },
  {
    _id: 3,
    date: "09/06/2025",
    time: "09:00",
    tenantName: "Alice Smith",
    unitId: "ID 1036",
    propertyName: "Propoerty C",
    amount: "UGX 150,000",
    reference: "MM",
    method: "Message",
    type: "resend",
    content: "Your Rent Payment Reminder for the month of August. Please ensure timely payment to avoid late fees."
  },
  {
    _id: 4,
    date: "09/06/2025",
    time: "09:00",
    tenantName: "John Edwin",
    unitId: "ID 1021",
    propertyName: "Property A",
    amount: "UGX 60,000",
    reference: "Bank",
    method: "Email",
    type: "scheduled",
    content: "Your Rent Payment Reminder for the month of June. Please ensure timely payment to avoid late fees."
  },
  {
    _id: 5,
    date: "09/08/2025",
    time: "14:00",
    tenantName: "Jane Doe",
    unitId: "ID 1024",
    propertyName: "Property B",
    amount: "UGX 60,000",
    reference: "MM",
    method: "Email",
    type: "resend",
    content: "Your Rent Payment Reminder for the month of June. Please ensure timely payment to avoid late fees."
  },
  {
    _id: 6,
    date: "09/06/2025",
    time: "09:00",
    tenantName: "Alice Smith",
    unitId: "ID 1036",
    propertyName: "Property D",
    amount: "UGX 50,000",
    reference: "Bank",
    method: "Message",
    type: "scheduled",
    content: "Your Rent Payment Reminder for the month of August. Please ensure timely payment to avoid late fees."
  },
  {
    _id: 7,
    date: "09/06/2025",
    time: "09:00",
    tenantName: "John Edwin",
    unitId: "ID 1021",
    propertyName: "Property H",
    amount: "UGX 60,000",
    reference: "Bank",
    method: "Email",
    type: "resend",
    content: "Your Rent Payment Reminder for the month of June. Please ensure timely payment to avoid late fees."
  },
  {
    _id: 8,
    date: "09/08/2025",
    time: "14:00",
    tenantName: "Jane Doe",
    unitId: "ID 1024",
    propertyName: "Property A",
    amount: "UGX 60,000",
    reference: "MM",
    method: "Email",
    type: "resend",
    content: "Your Rent Payment Reminder for the month of June. Please ensure timely payment to avoid late fees."
  },
];

export const PropertyUnits = {
  "UNT-001": {
    tenantName: "A-Tenant 1",
    propertyName: "Property A",
    unitName: "A-101",
    monthlyRent: "UGX 230000",
    deposit: "UGX 230000",
    paidThrough: "May 28, 2025",
    outstanding: "None",
    phone: "0700123456",
    status: "Occupied",
    payments: [
      {
        date: "May 13, 2025",
        amount: "UGX 230000",
        coveredFrom: "May 18, 2025",
        coveredTo: "Jun 17, 2025",
      },
            {
        date: "Apr 05, 2025",
        amount: "UGX 190000",
        coveredFrom: "Apr 10, 2025",
        coveredTo: "May 09, 2025",
      },
      {
        date: "Mar 05, 2025",
        amount: "UGX 190000",
        coveredFrom: "Mar 10, 2025",
        coveredTo: "Apr 09, 2025",
      },
      {
        date: "Feb 05, 2025",
        amount: "UGX 190000",
        coveredFrom: "Feb 10, 2025",
        coveredTo: "Mar 09, 2025",
      },
      {
        date: "Jan 05, 2025",
        amount: "UGX 190000",
        coveredFrom: "Jan 10, 2025",
        coveredTo: "Feb 09, 2025",
      },
      {
        date: "Dec 05, 2024",
        amount: "UGX 190000",
        coveredFrom: "Dec 10, 2024",
        coveredTo: "Jan 09, 2025",
      },
      {
        date: "Nov 05, 2024",
        amount: "UGX 190000",
        coveredFrom: "Nov 10, 2024",
        coveredTo: "Dec 09, 2024",
      },
      {
        date: "Oct 05, 2024",
        amount: "UGX 190000",
        coveredFrom: "Oct 10, 2024",
        coveredTo: "Nov 09, 2024",
      },
      {
        date: "Sep 05, 2024",
        amount: "UGX 190000",
        coveredFrom: "Sep 10, 2024",
        coveredTo: "Oct 09, 2024",
      },
      {
        date: "Aug 05, 2024",
        amount: "UGX 190000",
        coveredFrom: "Aug 10, 2024",
        coveredTo: "Sep 09, 2024",
      },
    ],
  },
  "UNT-002": {
    tenantName: "B-Tenant 2",
    propertyName: "Property B",
    unitName: "B-102",
    monthlyRent: "UGX 210000",
    deposit: "UGX 210000",
    paidThrough: "May 25, 2025",
    outstanding: "None",
    phone: "0700234567",
    status: "Occupied",
    payments: [
      {
        date: "May 10, 2025",
        amount: "UGX 210000",
        coveredFrom: "May 15, 2025",
        coveredTo: "Jun 14, 2025",
      },
    ],
  },
  "UNT-003": {
    tenantName: "C-Tenant 3",
    propertyName: "Property C",
    unitName: "C-103",
    monthlyRent: "UGX 250000",
    deposit: "UGX 250000",
    paidThrough: "May 30, 2025",
    outstanding: "None",
    phone: "0700345678",
    status: "Vacant",
    payments: [
      {
        date: "May 12, 2025",
        amount: "UGX 250000",
        coveredFrom: "May 17, 2025",
        coveredTo: "Jun 16, 2025",
      },
    ],
  },
  "UNT-004": {
    tenantName: "D-Tenant 4",
    propertyName: "Property D",
    unitName: "D-104",
    monthlyRent: "UGX 190000",
    deposit: "UGX 190000",
    paidThrough: "May 20, 2025",
    outstanding: "None",
    phone: "0700456789",
    status: "Occupied",
    payments: [
      {
        date: "May 05, 2025",
        amount: "UGX 190000",
        coveredFrom: "May 10, 2025",
        coveredTo: "Jun 09, 2025",
      },
      {
        date: "Apr 05, 2025",
        amount: "UGX 190000",
        coveredFrom: "Apr 10, 2025",
        coveredTo: "May 09, 2025",
      },
      {
        date: "Mar 05, 2025",
        amount: "UGX 190000",
        coveredFrom: "Mar 10, 2025",
        coveredTo: "Apr 09, 2025",
      },
      {
        date: "Feb 05, 2025",
        amount: "UGX 190000",
        coveredFrom: "Feb 10, 2025",
        coveredTo: "Mar 09, 2025",
      },
      {
        date: "Jan 05, 2025",
        amount: "UGX 190000",
        coveredFrom: "Jan 10, 2025",
        coveredTo: "Feb 09, 2025",
      },
      {
        date: "Dec 05, 2024",
        amount: "UGX 190000",
        coveredFrom: "Dec 10, 2024",
        coveredTo: "Jan 09, 2025",
      },
      {
        date: "Nov 05, 2024",
        amount: "UGX 190000",
        coveredFrom: "Nov 10, 2024",
        coveredTo: "Dec 09, 2024",
      },
      {
        date: "Oct 05, 2024",
        amount: "UGX 190000",
        coveredFrom: "Oct 10, 2024",
        coveredTo: "Nov 09, 2024",
      },
      {
        date: "Sep 05, 2024",
        amount: "UGX 190000",
        coveredFrom: "Sep 10, 2024",
        coveredTo: "Oct 09, 2024",
      },
      {
        date: "Aug 05, 2024",
        amount: "UGX 190000",
        coveredFrom: "Aug 10, 2024",
        coveredTo: "Sep 09, 2024",
      },
    ]
  },
  "UNT-005": {
    tenantName: "E-Tenant 5",
    propertyName: "Property E",
    unitName: "E-105",
    monthlyRent: "UGX 260000",
    deposit: "UGX 260000",
    paidThrough: "May 18, 2025",
    outstanding: "None",
    phone: "0700567890",
    status: "Vacant",
    payments: [
      {
        date: "May 01, 2025",
        amount: "UGX 260000",
        coveredFrom: "May 06, 2025",
        coveredTo: "Jun 05, 2025",
      },
    ],
  },
  "UNT-006": {
    tenantName: "F-Tenant 6",
    propertyName: "Property F",
    unitName: "F-106",
    monthlyRent: "UGX 220000",
    deposit: "UGX 220000",
    paidThrough: "May 26, 2025",
    outstanding: "None",
    phone: "0700678901",
    status: "Occupied",
    payments: [
      {
        date: "May 11, 2025",
        amount: "UGX 220000",
        coveredFrom: "May 16, 2025",
        coveredTo: "Jun 15, 2025",
      },
    ],
  },
  "UNT-007": {
    tenantName: "G-Tenant 7",
    propertyName: "Property G",
    unitName: "G-107",
    monthlyRent: "UGX 200000",
    deposit: "UGX 200000",
    paidThrough: "May 24, 2025",
    outstanding: "None",
    phone: "0700789012",
    status: "Vacant",
    payments: [
      {
        date: "May 09, 2025",
        amount: "UGX 200000",
        coveredFrom: "May 14, 2025",
        coveredTo: "Jun 13, 2025",
      },
    ],
  },
  "UNT-008": {
    tenantName: "H-Tenant 8",
    propertyName: "Property H",
    unitName: "H-108",
    monthlyRent: "UGX 240000",
    deposit: "UGX 240000",
    paidThrough: "May 29, 2025",
    outstanding: "None",
    phone: "0700890123",
    status: "Occupied",
    payments: [
      {
        date: "May 14, 2025",
        amount: "UGX 240000",
        coveredFrom: "May 19, 2025",
        coveredTo: "Jun 18, 2025",
      },
    ],
  },
  "UNT-009": {
    tenantName: "I-Tenant 9",
    propertyName: "Property I",
    unitName: "I-109",
    monthlyRent: "UGX 270000",
    deposit: "UGX 270000",
    paidThrough: "May 27, 2025",
    outstanding: "None",
    phone: "0700901234",
    status: "Occupied",
    payments: [
      {
        date: "May 13, 2025",
        amount: "UGX 270000",
        coveredFrom: "May 18, 2025",
        coveredTo: "Jun 17, 2025",
      },
    ],
  },
  "UNT-010": {
    tenantName: "J-Tenant 10",
    propertyName: "Property J",
    unitName: "J-110",
    monthlyRent: "UGX 280000",
    deposit: "UGX 280000",
    paidThrough: "May 31, 2025",
    outstanding: "None",
    phone: "0701012345",
    status: "Vacant",
    payments: [
      {
        date: "May 15, 2025",
        amount: "UGX 280000",
        coveredFrom: "May 20, 2025",
        coveredTo: "Jun 19, 2025",
      },
    ],
  },
};

export const ManageProperties = [
  {
    title: "Lakeside Villas",
    location: "City 1, Area 1",
    occupied: 7,
    vacant: 5,
    totalUnits: 12,
    expectedRent: "UGX 4,500,000",
    rentCollected: 10,
    rentCollectedThisMonth: "UGX 1,200,000",
  },
  {
    title: "Mountain View",
    location: "City 2, Area 3",
    occupied: 4,
    vacant: 8,
    totalUnits: 12,
    expectedRent: "UGX 3,800,000",
    rentCollected: 6,
    rentCollectedThisMonth: "UGX 900,000",
  },
  {
    title: "Downtown Lofts",
    location: "City 3, Area 2",
    occupied: 10,
    vacant: 2,
    totalUnits: 12,
    expectedRent: "UGX 5,200,000",
    rentCollected: 11,
    rentCollectedThisMonth: "UGX 1,500,000",
  },
  {
    title: "Sunset Residences",
    location: "City 1, Area 5",
    occupied: 8,
    vacant: 5,
    totalUnits: 12,
    expectedRent: "UGX 4,800,000",
    rentCollected: 7,
    rentCollectedThisMonth: "UGX 2,100,000",
  },
  {
    title: "Maple Heights",
    location: "City 2, Area 7",
    occupied: 12,
    vacant: 0,
    totalUnits: 12,
    expectedRent: "UGX 6,000,000",
    rentCollected: 12,
    rentCollectedThisMonth: "UGX 6,000,000",
  },
  {
    title: "Lakeside Court",
    location: "City 4, Area 1",
    occupied: 6,
    vacant: 6,
    totalUnits: 12,
    expectedRent: "UGX 3,600,000",
    rentCollected: 5,
    rentCollectedThisMonth: "UGX 1,200,000",
  },
];